import { ReactNode } from 'react';

import { ListItem, Typography, TypographyProps } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { Constants } from '@arrived/common';

const StyledQuickLookItemContainer = styled(ListItem)`
  &.property-details-quick-look-item {
    flex: 0 0 auto;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(0.25)};
    align-items: flex-start;
    width: auto;
    padding: 0;

    ${({ theme }) => theme.breakpoints.down('md')} {
      flex-direction: column;
      align-items: flex-start;
      gap: ${({ theme }) => theme.spacing(0.5)};
      margin-right: unset;
    }
  }
`;

interface PropertyDetailsQuickLookItemProps {
  className?: string;
  label?: ReactNode;
  value?: ReactNode;
  labelTypographyProps?: TypographyProps;
  valueTypographyProps?: TypographyProps;
  children?: ReactNode;
}

export const PropertyDetailsQuickLookItem = ({
  className,
  label,
  value,
  labelTypographyProps,
  valueTypographyProps,
  children,
}: PropertyDetailsQuickLookItemProps) => {
  return (
    <StyledQuickLookItemContainer className={clsx('property-details-quick-look-item', className)}>
      {children ?? (
        <>
          <Typography variant="body1" color={({ palette }) => palette.darkened.steel} {...labelTypographyProps}>
            {label}
          </Typography>
          <Typography variant="body1.semibold" {...valueTypographyProps}>
            {value ?? 'N/A'}
          </Typography>
        </>
      )}
    </StyledQuickLookItemContainer>
  );
};
